module.exports = __webpack_public_path__ + "static/media/tommySleeve4.31ce5c92.svg";